<div nz-row>
  <div nz-col nzSpan="8" nzOffset="8" [ngClass]="'register p-3'">
    <h1 nz-typography>Inregistrare</h1>

    <form
      nz-form
      [formGroup]="registerForm"
      class="register-form"
      (ngSubmit)="onSubmit()"
    >
      <nz-form-item>
        <!-- <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired nzFor="firstName">Nickname</nz-form-label> -->
        <nz-form-control nzErrorTip="Te rog sa adaugi prenumele tau!">
          <!-- <input nz-input formControlName="firstName" /> -->

          <nz-input-group [nzPrefix]="prefixNickname">
            <input
              type="text"
              nz-input
              formControlName="firstName"
              placeholder="Prenume"
            />
          </nz-input-group>
          <ng-template #prefixNickname>
            <i nz-icon nzType="user" nzTheme="outline"></i>
          </ng-template>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <!-- <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired nzFor="firstName">Nickname</nz-form-label> -->
        <nz-form-control nzErrorTip="Te rog sa adaugi numele tau!">
          <!-- <input nz-input formControlName="firstName" /> -->

          <nz-input-group [nzPrefix]="prefixNickname">
            <input
              type="text"
              nz-input
              formControlName="lastName"
              placeholder="Nume"
            />
          </nz-input-group>
          <ng-template #prefixNickname>
            <i nz-icon nzType="user" nzTheme="outline"></i>
          </ng-template>
        </nz-form-control>
      </nz-form-item>

      <!-- <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired nzFor="lastName">Lastname</nz-form-label>
                <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="Please input Lastname!">
                    <input nz-input formControlName="lastName" />
                </nz-form-control>
            </nz-form-item> -->

      <nz-form-item>
        <nz-form-control nzErrorTip="Adauga un email vaild!">
          <nz-input-group [nzPrefix]="prefixEmail">
            <input
              type="text"
              nz-input
              formControlName="email"
              placeholder="Email"
            />
          </nz-input-group>
          <ng-template #prefixEmail>
            <i nz-icon nzType="mail" nzTheme="outline"></i>
          </ng-template>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-control nzErrorTip="Confirmă adresa de email!">
          <nz-input-group [nzPrefix]="prefixEmail">
            <input
              type="text"
              nz-input
              formControlName="confirmemail"
              placeholder="Confirmă adresa de email"
            />
          </nz-input-group>
          <ng-template #prefixEmail>
            <i nz-icon nzType="mail" nzTheme="outline"></i>
          </ng-template>
        </nz-form-control>
      </nz-form-item>

      <!-- <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired nzFor="email">E-mail</nz-form-label>
                <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="Adauga un email vaild!">
                  <input nz-input formControlName="email" id="email" />
                </nz-form-control>
            </nz-form-item> -->

      <nz-form-item nz-row class="register-area">
        <nz-form-control
          [nzSpan]="24"
          [nzOffset]="0"
          nzErrorTip="Trebuie sa fii de acord cu termenii si conditiile"
        >
          <input type="checkbox" formControlName="agree" value="1" id="agree" />
          <label for="agree" nzValue="1">
            <span>
              Sunt de acord cu
              <a href="https://blog.doctorbusiness.ro/termeni-si-conditii"
                >termeni si conditiile</a
              >
            </span>
          </label>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item nz-row class="register-area">
        <nz-form-control [nzSpan]="24" [nzOffset]="0">
          <button
            nz-button
            nzType="primary"
            class="register-form-button register-form-margin"
            [nzLoading]="loading"
            [disabled]="registerForm.invalid"
          >
            Inregistrează-te!
          </button>
        </nz-form-control>
      </nz-form-item>

      <div nz-col [nzSpan]="24" class="register-links">
        <a routerLink="/login" (click)="goTop()">Ai cont? Autentifică-te!</a>
      </div>
    </form>
  </div>
</div>
